<template>
  <div v-if="documentUrl" class="heading-container">
    <ui-heading tag="h5">
      {{ title }}
    </ui-heading>
    <ui-button
      type="button"
      @click="previewDocument()"
      :disabled="isUpdating"
      variant="primary"
      class="lone-preview-btn"
    >
      {{ $t("additional_documents.viewSourceButton") }}
    </ui-button>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";
import { getMostRecentDocument } from "@/utils/documentPhoto";
import { handleDocumentPreview } from "./utils";
import { notificationHandlers } from "./Notification.mixins";

export default {
  props: {
    isUpdating: Boolean,
    documentType: String,
    title: String
  },
  data() {
    return {
      documentBlob: null
    };
  },
  mixins: [notificationHandlers],
  computed: {
    ...mapGetters([getters.currentIdentification]),

    document() {
      return this.currentIdentification?.data?.media?.filter(
        item => item.givenDocumentType === this.documentType
      );
    },

    documentUrl() {
      return getMostRecentDocument(this.document)?.url;
    },

    documentExtensionType() {
      return getMostRecentDocument(this.document)?.fileExtension;
    }
  },

  methods: {
    async previewDocument() {
      this.documentBlob = await handleDocumentPreview(
        this.documentUrl,
        this.documentExtensionType,
        this.documentBlob,
        this.displayNotification
      );
    }
  }
};
</script>
<style scoped lang="scss">
.heading-container {
  display: flex;
  justify-content: space-between;
}
button.lone-preview-btn {
  align-self: center;
  height: 2rem;
  margin-top: 0.25rem;
}
</style>
